<section class="banner-calculator">
    <div class="container-fluid">
        <div class="row v-row">
            <div class="col-lg-4 offset-lg-1">
<h2 class="sec_title">Make selling profitable</h2>
<p>With flexible fee structures, find the best fit for your business to grow faster and earn profits</p>
<button class="btn btn-style-bg " routerLink="/sellercalculator">Seller Calculator</button>
            </div>
            <div class="col-lg-7 pr-0">
<img src="assets/images/sellercalculator/slider.png">
            </div>
        </div>
    </div>
</section>

<section class="fees-section">
    <div class="container">
        <div class="row v-row">
            <div class="col-lg-3">
<h2 class="sec_title">Lorem Ipsum</h2>
<p>With flexible fee structures, find the best fit for your business to grow faster and earn profits</p>

            </div>
            <div class="col-lg-9 pr-0">
<div class="fees-content">

    <p class="main-fees-content">With flexible fee structures, find the best fit for your business to grow faster and earn profits</p>

    <ngx-slick-carousel
    class="carousel "
    #slickModal="slick-carousel"
    [config]="slideConfig"
  >
    <div
      ngxSlickItem
      *ngFor="let testimonial of testimonials"
      class="slide"
    >
    <div class=" fees-div">
        <img src="assets/images/icons/earn-more.png">
        <h2 class="sec_title">{{testimonial.subtitle}}</h2>
        <h4 class="sec_title">{{testimonial.title}}</h4>
        <p>With flexible fee structures, find the best fit for your business to grow faster and earn profits</p>
      
    </div>
    </div>
  </ngx-slick-carousel>
</div>
    <!-- <p class="main-fees-content">With flexible fee structures, find the best fit for your business to grow faster and earn profits</p> -->
    <!-- <div class="col-lg-3">
         </div>
                    </div>
                    <div class="col-lg-3">   <div class=" fees-div">
                        <img src="assets/images/icons/earn-more.png">
                        <h2 class="sec_title">Lorem Ipsum</h2>
                        <p>With flexible fee structures, find the best fit for your business to grow faster and earn profits</p>
                        
                    </div>
                </div>
                                    <div class="col-lg-3">   <div class=" fees-div">
                                        <img src="assets/images/icons/earn-more.png">
                                        <h2 class="sec_title">Lorem Ipsum</h2>
                                        <p>With flexible fee structures, find the best fit for your business to grow faster and earn profits</p>
                                        
                                    </div>
                                </div>
                                    <div class="col-lg-3"> 
                                </div> -->

            </div>
        </div>
    </div>
</section>